import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_ENDPOINT as string;

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
	baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}/api/` }),
	reducerPath: 'baseApi',
	endpoints: () => ({}),
});
